import { useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  MEUS_PEDIDOS_REEMBOLSO,
  MeusPedidosReembolsoData,
  MeusPedidosReembolsoVars,
} from '../services/pedidoReembolsoService';
import type { PedidoReembolso } from '../types/pedidoReembolso';

// Hook dono da consulta de meusPedidosReembolso (financeiro-dashboard-atleta Phase 5, Task 4 do
// plano; AC-A1). useQuery com o documento importado do service — não a função imperativa
// (MockedProvider intercepta hooks, não apolloClient.query). Recorte pelo token (guard S-1): a
// query não aceita nenhum parâmetro de identificação. Nenhum useMemo/useCallback sem
// justificativa (ai/anti-patterns.md §7); nenhuma soma de valor monetário.

export interface UseMeusReembolsosResult {
  pedidos: PedidoReembolso[];
  page: number;
  size: number;
  totalItems: number;
  totalPages: number;
  setPage: (page: number) => void;
  setSize: (size: number) => void;
  loading: boolean;
  error: Error | undefined;
  refetch: () => void;
}

export function useMeusReembolsos(): UseMeusReembolsosResult {
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  const query = useQuery<MeusPedidosReembolsoData, MeusPedidosReembolsoVars>(
    MEUS_PEDIDOS_REEMBOLSO,
    { variables: { page, size }, fetchPolicy: 'no-cache' },
  );

  const conexao = query.data?.meusPedidosReembolso ?? null;

  return {
    pedidos: conexao?.items ?? [],
    page,
    size,
    totalItems: conexao?.totalItems ?? 0,
    totalPages: conexao?.totalPages ?? 0,
    setPage,
    setSize,
    loading: query.loading,
    error: query.error,
    refetch: () => query.refetch(),
  };
}
